import { FC, useCallback, useEffect, useState } from 'react';
import { Setting } from '../../types/constant/PagesPropsType';
import changePaymentMethodClass from '../../assets/scss/SubscriptionDetail/ChangePaymentMethod.module.scss';
import { postMessageGtag } from '../../utils/trackClick';
import { CustomerPaymentMethod } from '../../types/api/SubscriptionApiType';

const instrumentTypeLabels: Record<string, string> = {
  CustomerCreditCard: 'クレジットカード',
  CustomerPaypalBillingAgreement: 'Paypal',
  CustomerShopPayAgreement: 'Shop Pay',
};

export const ChangePaymentMethod: FC<{
  loading: boolean;
  setting: Setting;
  customerPaymentMethod: CustomerPaymentMethod | null | undefined;
  clickOkBtnFunc: () => void;
}> = ({ loading, setting, customerPaymentMethod, clickOkBtnFunc }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const height = document.querySelector('body')!.scrollHeight;
    setting.resize(height);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const clickOkBtnHandler = useCallback(() => {
    clickOkBtnFunc();
  }, [clickOkBtnFunc]);

  const clickToggle = useCallback(() => {
    setIsOpen((prev) => !prev);
    postMessageGtag('click_open_payment', 'detailSettings');
  }, []);

  // クラス切り替え
  const angleClass = isOpen ? changePaymentMethodClass.angleUp : changePaymentMethodClass.angleDown;
  const containerClass = isOpen ? changePaymentMethodClass.open : changePaymentMethodClass.closed;

  const content = (
    <>
      <div className={changePaymentMethodClass.changePaymentMethod}>
        <button
          className={changePaymentMethodClass.title}
          onClick={clickToggle}
        >
          支払方法を確認・変更する
          <span className={angleClass}></span>
        </button>
        <div className={containerClass}>
          {/* 支払方法の確認 */}
          {customerPaymentMethod && (
            <div style={{ marginTop: '20px' }}>
              <div className={changePaymentMethodClass.messageTitle}>支払方法の確認</div>
              <div className={changePaymentMethodClass.customerPaymentMethodContainer}>
                <div className={changePaymentMethodClass.customerPaymentMethodTitle}>
                  お客様の支払い情報
                </div>
                <div className={changePaymentMethodClass.customerPaymentMethodItemWrapper}>
                  {customerPaymentMethod.instrumentType && (
                    <div className={changePaymentMethodClass.customerPaymentMethodItem}>
                      <div className={changePaymentMethodClass.customerPaymentMethodItemTitle}>
                        支払い方法
                      </div>
                      <div>
                        {instrumentTypeLabels[customerPaymentMethod.instrumentType] ??
                          'クレジットカード'}
                      </div>
                    </div>
                  )}
                  {customerPaymentMethod.instrumentLastDigits && (
                    <div className={changePaymentMethodClass.customerPaymentMethodItem}>
                      <div className={changePaymentMethodClass.customerPaymentMethodItemTitle}>
                        番号
                      </div>
                      <div>**** **** **** {customerPaymentMethod.instrumentLastDigits}</div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          {/* 支払方法の変更 */}
          <div style={{ marginTop: '40px' }}>
            <div className={changePaymentMethodClass.messageTitle}>支払方法の変更</div>
            <div className={changePaymentMethodClass.message}>
              ご登録のメールアドレスに、支払い方法の変更ページの案内を送付します。
            </div>
          </div>
          <div className={changePaymentMethodClass.btnContainer}>
            <button
              onClick={() => {
                clickOkBtnHandler();
                postMessageGtag('click_payment', 'detailSettings');
              }}
              disabled={loading}
            >
              案内メールを送付する
            </button>
          </div>
        </div>
      </div>
    </>
  );

  return content;
};
